import { render, staticRenderFns } from "./ChecklisttypesCrud.vue?vue&type=template&id=3a1cfa5a"
import script from "./ChecklisttypesCrud.vue?vue&type=script&lang=js"
export * from "./ChecklisttypesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports